import React, {  useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import Dollar from '../components/Icon/Dollar';
import { useData } from '../context/DataProvider';
import ProductModal from '../components/ProductModal';

import BackToTopIcon from '../components/Icon/arrow-circle-top-svgrepo-com.svg'
import BlackFire from '../components/Icon/BlackFire';
import Barcode from '../components/Icon/Barcode';

import { useLocation, useParams } from 'react-router-dom';
import DropdownIcon from '../components/Icon/DropdownIcon'
import DiagonalStripeBackground from '../components/DiagonalStripeBackground';
import Loader from '../components/Loader';
import { CrossIcon } from '../components/Icon/CrossIcon';


import Fire2 from '../components/Icon/Fire2';
import RisingFast2 from '../components/Icon/RisingFast2';
import Gaining2 from '../components/Icon/Gaining2';
import Steady2 from '../components/Icon/Steady2';
import Emerging2 from '../components/Icon/Emerging2';
import { tagColors } from './Trends';
import { cosmeticIQApi } from '../service/api';
import Heart from '../components/Icon/Heart';
import HeartHollow from '../components/Icon/HeartHollow';

const Trend = (props) => {
  const [trendData, setTrendData] = useState();
  const {getTrendById,data,setData} = useData();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedBrands, setSelectedBrands] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedPrices, setSelectedPrices] = useState([]);
    
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [selectedBrandOrigin,setSelectedBrandOrigin] = useState([]);
    const [selectedTrends, setSelectedTrends] = useState([]);
    const [selectedTimeRange, setSelectedTimeRange] = useState(null);
    const [selectedSegment, setSelectedSegment] = useState(null); 
    const [showBackToTop, setShowBackToTop] = useState(false);
    const location = useLocation();
    const trendId = location.state?.trendId;
    const classification = location.state?.classification;
    const discoveryTags = location.state?.discoveryTags || [];
    const tableContainerRef = useRef(null);
    useEffect(() => {
      
        const handleScroll = () => {
          if (tableContainerRef.current) {
            const scrollTop = tableContainerRef.current.scrollTop;
            setShowBackToTop(scrollTop > 300);
          }
        };
    
        const container = tableContainerRef.current;
        if (container) {
          container.addEventListener('scroll', handleScroll);
          return () => container.removeEventListener('scroll', handleScroll);
        }
      }, []);
    
    const filtersRef = useRef();
    const handleRowClick = (product) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
  };
 
const getContextualCallouts = (data) => {
  const total = data?.trend_metrics?.total || data?.products?.length || 0;
  if (!total) return [];

  const callouts = [];

  Object.entries(data?.brand_laneway_count || {}).forEach(([laneway, count]) => {
    const share = (count / total) * 100;
    if (share > 40) {
      callouts.push({
        key: `laneway-${laneway}`,
        type: 'laneway',
        title: 'Brand Laneway Leader',
        headline: `${laneway} brands account for ${Math.round(share)}% of products in this trend`,
        sub: `${count} of ${total} products`,
      });
    }
  });

  Object.entries(data?.brand_origin_count || {}).forEach(([country, count]) => {
    const share = (count / total) * 100;
    if (share > 50) {
      callouts.push({
        key: `origin-${country}`,
        type: 'origin',
        title: 'Origin Signal',
        headline: `This trend is predominantly driven by ${country} brands (${Math.round(share)}% of products)`,
        sub: `${count} of ${total} products`,
      });
    }
  });
  return callouts;
};
  
  const {id} = useParams();
  const [openDropdown, setOpenDropdown] = useState(null);
  const [loading, setLoading] = useState(false);
  const getGradient = (height) => {
  const blue = height;
  const remaining = 100 - blue;
  const middle = remaining / 2;

  return `linear-gradient(
    to bottom,
    #BDDEFF 0%,
    #BDDEFF ${blue}%,
    #EFFFB9 ${blue}%,
    #EFFFB9 ${blue + middle}%,
    #DCFFAD ${blue + middle}%,
    #DCFFAD 100%
  )`;
};
useEffect(() => {
  const handleClickOutside = (e) => {
    if (filtersRef.current && !filtersRef.current.contains(e.target)) {
      setOpenDropdown(null);
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => document.removeEventListener('mousedown', handleClickOutside);
}, []);
const colorsArr = ['#BDDEFF','#F6FFDB','#EDFFB8','#DCFFAD','#E9E9E9','#FFFFFF']
  const toggleBrandSelection = (brand) => {
    setSelectedBrands(prev => 
      prev.includes(brand) 
        ? prev.filter(b => b !== brand)
        : [...prev, brand]
    );
  };
  const toggleBrandOriginSelection = (brandOrigin) => {
    setSelectedBrandOrigin(prev => 
      prev.includes(brandOrigin) 
        ? prev.filter(b => b !== brandOrigin)
        : [...prev, brandOrigin]
    );
  };

  const togglePriceSelection = (price) => {
    setSelectedPrices(prev => 
      prev.includes(price) 
        ? prev.filter(p => p !== price)
        : [...prev, price]
    );
  };
const clearFilters = () => {
  setOpenDropdown(null);
    setSelectedBrands([]);
    setSelectedTrends([]);
    
    setSelectedPrices([]);
    
    setSelectedCategories([]);
    setSelectedBrandOrigin([]);
    setSelectedTimeRange(null);
    
  };
  const toggleCategorySelection = (category) => {
    setSelectedCategories(prev => 
      prev.includes(category) 
        ? prev.filter(c => c !== category)
        : [...prev, category]
    );
  };
  const toggleTrendSelection = (trend) => {
    setSelectedTrends(prev => 
      prev.includes(trend) 
        ? prev.filter(a => a !== trend)
        : [...prev, trend]
    );
  };

   const uniqueBrands = [
  ...new Set(trendData?.products.map(product => product.brand))
].sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));

const uniqueBrandOrigins = [
  ...new Set(trendData?.products.map(product => product.brand_origin))
].sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));

  const priceOptions = ["1", "2", "3", "4"];
  const uniqueCategories = selectedSegment?.categories 
  ? selectedSegment?.categories.map(cat => cat.category_name).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
  : [...new Set(
      trendData?.products.flatMap(product => product.categories.map(cat => cat.name))
    )].sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
  
 
 const uniqueTrends = [
  ...new Set(
    trendData?.products.flatMap(product =>
      product.attributes
        .filter(attr => attr.type === 'Trend')
        .map(attr => attr.name)
    )
  )
].sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));

  useEffect(() => {
  let isMounted = true;

  (async () => {
    try {
      const resp = await getTrendById(trendId);
      if (isMounted) setTrendData(resp);
    } catch (e) {
      
    }
  })();

  return () => { isMounted = false; };
}, [id]);
const totalProducts = trendData?.trend_metrics?.total || 8;
const categoriesList = Object.entries(trendData?.category_count || {})
  .map(([categoryName, count]) => {
    const percentage = ((count / totalProducts) * 100).toFixed(0);

    return {
      name: categoryName,
      count,
      percentageString: percentage,
      decimalPercentage: count / totalProducts,
    };
  })
  .sort((a, b) => b.count - a.count); 
  
  const brandList = Object.entries(trendData?.brand_count || {}).map(([brandName, count]) => {
    
    const sharePercentage = ((count / totalProducts) * 100).toFixed(1); 

    
    const matchingProduct = trendData?.products?.find(p => p.brand === brandName);
    const primarySku = matchingProduct?.skus?.[0];
    
    
    const priceText = primarySku 
      ? `${primarySku.price} ${primarySku.currency}` 
      : "N/A";

    return {
      name: brandName,
      count: count,
      percentageString: sharePercentage,
      subtext: `${count} product${count > 1 ? 's' : ''}`
    };
  });
  const totalCount = trendData?.trend_metrics?.total || trendData?.products.length;

  
  const formatDate = (dateString) => {
    if (!dateString || dateString.startsWith('1970')) return '01.01.2021'; 
    try {
      const [year, month, day] = dateString.split(' ')[0].split('-');
      return `${day}.${month}.${year}`;
    } catch (e) {
      return '01.01.2021';
    }
  };

  
  const renderPriceTier = (priceRangeNum) => {
  const numericRange = parseInt(priceRangeNum, 10) || 1;

  return (
    <>
      {Array.from({ length: numericRange }, (_, index) => (
        <Dollar key={index} />
      ))}
    </>
  );
};
 const scrollToTop = () => {
    if (tableContainerRef.current) {
      tableContainerRef.current.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };
const filteredProducts = trendData?.products.filter((product) => {
  
  
  const matchesPrices =
    selectedPrices.length === 0 ||
    selectedPrices.some(price => {
      const priceValue = price.length;
      const productPriceRange = parseInt(product.priceRange || '0');
      return priceValue === productPriceRange;
    });

  const matchesBrands =
    selectedBrands.length === 0 ||
    selectedBrands.includes(product.brand);
 

  const matchesBrandOrigins =
    selectedBrandOrigin.length === 0 ||
    selectedBrandOrigin.includes(product.brand_origin);
 

  const matchesCategories =
    selectedCategories.length === 0 ||
    product.categories.some(cat => selectedCategories.includes(cat.name));
  
  const matchesTrends =
    selectedTrends.length === 0 ||
    product.attributes.some(attr => selectedTrends.includes(attr.name));

  

  const matchesTimeRange = !selectedTimeRange || (() => {
    const months = parseInt(selectedTimeRange);
    const productDate = new Date(product.date_launched);
    const thresholdDate = new Date();
    thresholdDate.setMonth(thresholdDate.getMonth() - months);
    
    return productDate > thresholdDate;
  })();
  return (
    
    matchesPrices &&
    matchesBrands &&
    matchesCategories &&
    matchesBrandOrigins &&
   
    matchesTrends &&
   
    matchesTimeRange 
   
   
  );
});

const growthData = trendData?.ingredient_market_share || {};
const bgColors = [
  "#BDDEFF",
  "#C7E5F1",
  "#D2EBE3",
  "#DCF2D5",
  "#E7F8C7",
  "#EFFFB9",
  "#EBFFB6",
  "#E6FFAF",
  "#E1FFA9",
  "#DCFFAD"
]
  
  const cleanIngredientName = (rawName) => {
    return rawName.split(' (')[0].trim();
  };

  const toggleTrendSave = async () => {
  
  const savedIds = data?.savedTrends?.savedTrendIds || [];

  setLoading(true);
  try {
  
    const isSaved = savedIds.includes(trendId);

    if (isSaved) {
      await cosmeticIQApi.unsaveTrend(trendId);
    } else {
      await cosmeticIQApi.saveTrend(trendId);
    }

   
    const resp = await cosmeticIQApi.fetchSavedTrends();
    setData(prev => ({ ...prev, savedTrends: resp }));
  } catch (error) {
    console.error("Failed to toggle trend save status:", error);
  } finally {
    setLoading(false);
  }
};
  
  const ingredientsList = Object.entries(trendData?.ingredient_count || {})
    .map(([rawName, count]) => {
      const cleanName = cleanIngredientName(rawName);
      const percentage = Math.round((count / totalProducts) * 100);
      const growth = growthData[rawName] || '0%';

      return {
        name: cleanName,
        count: count,
        percentageString: `${percentage}%`,
        percentageValue: percentage, 
        growthString: growth
      };
    })
    .sort((a, b) => b.count - a.count); 
  
  
  const topTenBrands = [...brandList]
  .sort((a, b) => b.count - a.count)
  .slice(0, 10);
  const maxCount = topTenBrands[0]?.count || 1;
  const renderMultiSelectDropdown2 = (
    isOpen, 
    setIsOpen, 
    selectedOptions, 
    options, 
    toggleSelection, 
    placeholder
  ) => (
    <DropdownWrapper style={{flex:1,padding:0}}>
      <DropdownInput 
        style={{
          background: selectedOptions.length > 0 
            ? 'linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%)' 
            : '#FFFFFF'
        }} 
       onClick={() =>
  setOpenDropdown(openDropdown === placeholder ? null : placeholder)
}

      >
        
        {selectedOptions.length > 0 
          ? selectedOptions.length > 1 ? 'Mulitple Options Selected'
          : selectedOptions[0] : placeholder}
        <DropdownIcon />
      </DropdownInput>
      <OptionsList isOpen={openDropdown === placeholder}>
        {options.map((option, index) => (
          <DropdownOption
            key={option}
            onClick={() => toggleSelection(option)}
            style={{
              backgroundColor: selectedOptions.includes(option) 
                ? '#E0F2FE' : 'white',
              borderTopLeftRadius: index === 0 ? "8px" : "0",
              borderTopRightRadius: index === 0 ? "8px" : "0",
              borderBottomLeftRadius: index === options.length - 1 ? "8px" : "0",
              borderBottomRightRadius: index === options.length - 1 ? "8px" : "0",
              
            }}
          >
            {option}
            {selectedOptions.includes(option) && '✓'}
          </DropdownOption>
        ))}
      </OptionsList>
    </DropdownWrapper>
  );
  return (
    <Container ref={tableContainerRef}>
      
       <ProductModal
              isOpen={isModalOpen} 
              onClose={() => setIsModalOpen(false)}
              product={selectedProduct}
            />
      {!trendData ? <LoaderArea><Loader /></LoaderArea>:
        <InnerContainer>
            <div style={{justifyContent:'space-between',flexDirection:"row",display:'flex',alignItems:'center'}}>
              
            <In1>
                <In1Text>{trendData?.trend_name}</In1Text>
                 {classification === 'Most Active' && <Fire2 />}
            {classification === 'Rising Fast' && <RisingFast2 />}
            {classification === 'Gaining Momentum' && <Gaining2 />}
            {classification === 'Emerging' && <Emerging2 />}
            {classification === 'Steady' && <Steady2 />}
            </In1>
           <div style={{flexDirection:'row',display:'flex',alignItems:'center',gap:8}}>
            {loading &&<Loader />}
         <button style={{outline:'none',border:'none',background:'transparent',cursor:'pointer'}} onClick={()=>toggleTrendSave()}>
  {(data?.savedTrends?.savedTrendIds || []).some((item) => item === trendId)
    ? <Heart/>
    : <HeartHollow/>}
</button>
</div>
            </div>
            <In2>
                  <Tag>
                            <TagText>{classification}</TagText>
                        </Tag>
                        <In31>
                            <TagText>{totalCount}</TagText>
                            <Barcode/>
                        </In31>
                         {discoveryTags.map((tag) => (
    <DiscoveryTagPill key={tag.key} color={tag.color}>
      {tag.label.toUpperCase()}
    </DiscoveryTagPill>
  ))}
                        </In2>
                        {getContextualCallouts(trendData).length > 0 &&
                        <div style={{minHeight:123,gap:8,flexDirection:'row',display:'flex',width:'100%'}}>
  {getContextualCallouts(trendData).map((callout, index) => (
  <div
    key={callout.key}
    style={{
      background: callout.type === 'laneway' ? '#E7FFC6' : '#E4CDFF',
      gap: 10,
      padding: 24,
      display: 'flex',
      flexDirection:'column',
      justifyContent:'space-between',
      borderRadius: 16,
      flex: '0 1 calc(50% - 4px)', 
    }}
  >
    <B2Text style={{lineHeight:'110%',color:'#202327',textAlign:'start'}}>
      {callout.title}
    </B2Text>
    <PP>{callout.headline}</PP>
    <PerText3 style={{color:"#2F323799",lineHeight:'140%'}}>{callout.sub}</PerText3>
  </div>
))}
</div>
}
                        <In4>
                            <In>
                            <In41>
                            <In4Text>Top BRANDS leading this trend</In4Text>
                            {/* <In411>
                                <In411Text1>TIME PERIOD</In411Text1>
                                <In411Text2>LAST 30 DAYS</In411Text2>
                            </In411> */}
                            </In41>
                            </In>
                        <In5>
                            <In51>
                       {topTenBrands.map((item, index) => {
  
  const relativePercentage = Math.round((item.count / maxCount) * 100);

  return (
    <II key={index}>
      <DiagonalStripeBackground>
        <In511 style={{ height: `${relativePercentage}%`, background: bgColors[index] }}>
          {/* <In512>
            <In513>
              <In513Text>{relativePercentage}%</In513Text>
            </In513>
          </In512> */}
        </In511>
      </DiagonalStripeBackground>

      <In61>
        <In61Text1>{item.subtext}</In61Text1>
        <In61Text2>{item.name}</In61Text2>
      </In61>
    </II>
  );
})}
                                </In51>
                               
                                
                                

                                
                            

                            </In5>        
                        </In4>   
                        <In4>
                            <In>
                            <In41>
                            <In4Text>Top CATEGORIES leading this trend</In4Text>
                          
                            </In41>
                            </In>
                        <In5 style={{flexDirection:"row",}}>
                            <In51 style={{width:'50%',flex:1}}>
                                {[...categoriesList]
  .sort((a, b) => Number(b.percentageString) - Number(a.percentageString))
  .slice(0, 6)
  .map((cat, index) => (
    <DiagonalStripeBackground key={index}>
      <In511
        style={{
          height: `${cat.percentageString}%`,
          background: colorsArr[index],
        }}
      >
        <In512>
          <In513Text>{cat.percentageString}%</In513Text>
        </In512>
      </In511>
    </DiagonalStripeBackground>
  ))}
                                </In51>
                                <Q>
                                    {[...categoriesList]
  .sort((a, b) => Number(b.percentageString) - Number(a.percentageString))
  .slice(0, 6)
  .map((cat, index) => (
    <QItem key={index}>
      <Q1>
        <Per
          last={index === 5}
          background={colorsArr[index]}
        >
          <PerText>{cat.percentageString}%</PerText>
        </Per>

        <PerText2>{cat.name}</PerText2>
        <PerText3>{cat.count} products</PerText3>
      </Q1>
    </QItem>
  ))}

                                </Q>
                                
                               

                            </In5>        
                        </In4>   
                        <In4>
                            <In>
                            <In41>
                            <In4Text>Most common INGREDIENTS inside this trend</In4Text>
                            </In41>
                           
                            </In>
                             <A>
                                <A1>
                                    <A11>
                                    <HText>Ingredient</HText>
                                    </A11>
                                    <A12>
                                    <HText>Number of products</HText>
                                    </A12>
                                    <A12>
                                    <HText>% of products</HText>
                                    </A12>
                                    <A11></A11>
                                    <A12>
                                    <HText>% in market</HText>
                                    </A12>

                                </A1>

                            </A>
                           {ingredientsList.map((ingredient, index) => (
                           <>
                           <Line2/>
                            <B>
                                <A1 style={{cursor:'default'}}>
                                    <A11>
                                        <B1>
                                            
                                            <B1Text>{ingredient.name}</B1Text>

                                        </B1>
                                    
                                    </A11>
                                    <A12>
                                    <B2Text>{ingredient.count} product{ingredient.count > 1 ? 's' : ''}</B2Text>
                                    </A12>
                                    <A12>
                                    <B2Text style={{color:'#202327'}}>{ingredient.percentageString}</B2Text>
                                    </A12>
                                    <A11>
                                        <C>
                                            <C1 style={{width: `${ingredient.percentageValue}%`,}}>

                                            </C1>

                                        </C>
                                    </A11>
                                    <A12>
                                    <B2Text style={{color:'#202327'}}>{ingredient.growthString}</B2Text>
                                    </A12>
                                    </A1>
                                
                            </B></>
                            ))}
                         
                        
                        </In4>   
                        <In4>
                            <In>
                            <D>
                                <D1>
                                    <D1Text style={{color:'#20232799'}}>TOTAL OF</D1Text>
                                    <D1Text style={{color:'##202327'}}>{filteredProducts?.length} product{filteredProducts?.length > 1 && 's'}</D1Text>
                                </D1>
                            <In4Text>All PRODUCTS in this trend</In4Text>
                            </D>
                           
                            </In>
                             <A style={{flexDirection:"column"}}>
                                   <div style={{display:'flex',gap:10,width:'100%'}} ref={filtersRef}>
                                        {renderMultiSelectDropdown2(
                                         openDropdown === "Brands",
                                         () => setOpenDropdown(openDropdown === "Brands" ? null : "Brands"),
                                         selectedBrands, 
                                         uniqueBrands, 
                                         toggleBrandSelection, 
                                         "Brand"
                                       )}
                           
                                       {renderMultiSelectDropdown2(
                                         openDropdown === "Time",
              () => setOpenDropdown(openDropdown === "Time" ? null : "Time"),
              selectedTimeRange ? [selectedTimeRange + " months"] : [],
              ["3 months", "6 months", "12 months"],
              (rangeLabel) => {
                const num = rangeLabel.split(' ')[0];
    setSelectedTimeRange(prev => prev === num ? null : num);
  },
                                         "Launch date"
                                       )}
                                       {/* { renderMultiSelectDropdown2(
                                         openDropdown === "Trend",
                                         () => setOpenDropdown(openDropdown === "Trend" ? null : "Trend"),
                                         selectedTrends, 
                                         uniqueTrends, 
                                         toggleTrendSelection, 
                                         "Trend"
                                       )} */}
                                       {renderMultiSelectDropdown2(
                                        openDropdown === "Price",
              () => setOpenDropdown(openDropdown === "Price" ? null : "Price"),
              selectedPrices,
              priceOptions.map(p => "$".repeat(parseInt(p))),
              togglePriceSelection,
              "Price"
                                       )}
                                        {
                                       
                                       renderMultiSelectDropdown2(
                                         openDropdown === "Category",
                                         () => setOpenDropdown(openDropdown === "Category" ? null : "Category"),
                                         selectedCategories,
                                         uniqueCategories,
                                         toggleCategorySelection,
                                         "Category"
                           )}
                             {renderMultiSelectDropdown2(
                                         openDropdown === "Country of Origin",
                                         () => setOpenDropdown(openDropdown === "Country of Origin" ? null : "Country of Origin"),
                                         selectedBrandOrigin,
                                         uniqueBrandOrigins,
                                         toggleBrandOriginSelection,
                                         "Country of Origin"
                           )}
                            <ClearBtn onClick={clearFilters}>
                                         
                                       <CrossIcon/>
                                     </ClearBtn>
                           
                                       
                                         
                                       
                                     </div>    
                                     <div style={{borderRadius:14,borderWidth:1,borderColor:'#2023271A',borderStyle:"solid",}}>
                                    <B style={{ paddingRight: 30, paddingLeft: 30, paddingTop: 32, paddingBottom: 32 }}>
  <A1 style={{ alignItems: 'center' }}>
    <A11 style={{ width: '40%', gap: 30, display: 'flex', alignItems: 'center' }}>
      <HText>Product</HText>
    </A11>
    <A12 style={{ flex: 1 }}>
      <HText>Launch date</HText>
    </A12>
    <A12 style={{ flex: 1 }}>
      <HText>Price</HText>
    </A12>
    <A12 style={{ flex: 1 }}>
      <HText>Category</HText>
    </A12>
    <A12 style={{ flex: 1 }}>
      <HText>Country of origin</HText>
    </A12>
  </A1>
</B>
                                     {filteredProducts?.map((product,index) => (
                           <>
                           {<Line2/>}
                            <B style={{ paddingRight: 30, paddingLeft: 30, paddingTop: 20, paddingBottom: 20, height: 110 }}>
  <A1 style={{ alignItems: 'center' }} onClick={() => handleRowClick(product)}>
    <A11 style={{ width: '40%', gap: 30, display: 'flex', alignItems: 'center' }}>
      <ImageC>
        <IMM src={product.image?.medium || product.image?.small} alt={product.name} />
      </ImageC>
      <Tt>
        <TtText1>{product.brand}</TtText1>
        <TtText2>{product.name}</TtText2>
      </Tt>
    </A11>
    <A12 style={{ flex: 1 }}>
      <B2Text>{formatDate(product.date_launched || product.date_created)}</B2Text>
    </A12>
    <A12 style={{ flex: 1 }}>
      <B2Text style={{ color: '#202327' }}>{renderPriceTier(product.priceRange)}</B2Text>
    </A12>
    <A12 style={{ flex: 1 }}>
      <B2Text style={{ color: '#202327' }}>{product.categories?.[0]?.name || '-'}</B2Text>
    </A12>
    <A12 style={{ flex: 1 }}>
      <B2Text style={{ color: '#202327' }}>{product?.brand_origin || '-'}</B2Text>
    </A12>
  </A1>
</B>
                            
                            </>
                            ))} 
                            </div>

                            </A>
                           
                         
                        
                        </In4>   
                             
{showBackToTop && (
                <BackToTopButton onClick={scrollToTop}>
                  <img src={BackToTopIcon} alt='backToTopIcon' width={50} height={50}/>
                </BackToTopButton>
               )}  
        </InnerContainer>
} 

    </Container>
  );
};
const ClearBtn = styled.button`
background: none;
cursor:pointer;
border:none;
display:flex;
justify-content:center;
align-items:center;
`
const LoaderArea = styled.div`
width:100%;
height:100%;
align-items:center;
display:flex;
justify-content:center;

`
const D1 = styled.div`

height: 24px;
padding-top: 4px;
padding-right: 10px;
padding-bottom: 4px;
padding-left: 10px;
display: inline-flex;
background: #FFFFFF;
gap: 10px;
border-radius: 4px;
`
const D1Text = styled.p`
font-family: PP Mori;
font-weight: 700;
font-style: Bold;
font-size: 12px;
leading-trim: NONE;
line-height: 120%;
letter-spacing: -1%;
text-align: center;
vertical-align: bottom;
text-transform: uppercase;
margin:0;
`
const D = styled.div`
gap:24;
flex-direction:column;
`

const C = styled.div`
width:100%;
height: 32px;
border-radius: 24px;

border: 1.5px solid #2023271A
`
const C1 = styled.div`
border-radius: 24px;
height:100%;
background: linear-gradient(90deg, #BDDEFF 0%, #EFFFB9 50%, #DCFFAD 100%);

`

const B = styled.div`
display:flex;

gap:24;
flex-direction:column;
// height:60px;
align-items:center;
justify-content:end;

// border-style: solid;
// border-width: 1px 0px 0px 0px;
// border-color: #2023271A;


`
const Line2 = styled.div`
background: #2023271A;
height:1px;
width:100%;
`
const A1 = styled.div`
border:none;
outline:none;
cursor:pointer;
display:flex;

width:100%;
flex-direction:row;
justify-content:space-between;

`
const A11 = styled.div`
width:20%;
display:flex;
align-items:center;
justify-content:start;

`
const B2Text = styled.p`
font-family: PP Mori;
font-weight: 600;
font-style: SemiBold;
font-size: 16px;
leading-trim: NONE;
line-height: 130%;
letter-spacing: 0%;
text-align: center;
margin:0;
color:#20232799;
`
const B1Text = styled.p`
font-family: PP Mori;
font-weight: 700;
font-style: Bold;
font-size: 18px;
leading-trim: NONE;
line-height: 120%;
letter-spacing: -1%;
// text-align: center;
vertical-align: bottom;
color:#000000;
margin:0;
`
const B1= styled.div`
display:flex;
gap:8px;

`
const A12 = styled.div`

width:20%;
`
const ImageC = styled.div`
width: 70px;
height: 70px;
border-radius: 12px;
background-color:white;
padding: 6px;
gap: 20.87px;

`
const Tt = styled.div`
display:flex;
height: 47px;
gap: 4px;

flex-direction:column;

`
const TtText1 = styled.p`
font-family: PP Mori;
margin:0;
font-weight: 600;
font-style: SemiBold;
font-size: 16px;
leading-trim: NONE;
line-height: 120%;
color:#20232799;

`
const TtText2 = styled.p`
display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
font-family: PP Mori;
font-weight: 600;
font-style: SemiBold;
margin:0;
font-size: 20px;
leading-trim: NONE;
line-height: 120%;
letter-spacing: -1%;
color:#202327;

`
const PP = styled.p`
font-family: PP Mori;
font-weight: 500;
font-style: Medium;
font-size: 14px;
leading-trim: NONE;
line-height: 140%;
letter-spacing: 0%;
color:#2F3237;
`
const IMM = styled.img`
width:58px;
height:58px;`
const HText = styled.p`
font-family: PP Mori;
font-weight: 700;
font-style: Bold;
font-size: 14px;
leading-trim: NONE;
line-height: 120%;
letter-spacing: -1%;
text-align: center;
vertical-align: bottom;
margin:0;
color:#000000;
`
const A = styled.div`
display:flex;
gap: 16px;
`
const PerText = styled.h1`
font-family: PP Mori;
font-weight: 700;
font-style: Bold;
font-size: 12px;
leading-trim: NONE;
line-height: 120%;
letter-spacing: -1%;
text-align: center;
vertical-align: bottom;
text-transform: uppercase;
color:#202327;

`
const Per = styled.div`
 border-color: ${({ last, background='white' }) =>
  last ? '#202327' : background};
      border-width: 1px;
      border-style:solid;
height: 22px;
width: 41px;
justify-content:center;
border-radius: 4px;
align-items:center;
display:flex;
background:  ${({ background = 'white' }) => background};
padding-right: 8px;
padding-left: 8px;

`
const PerText3 = styled.h1`
font-family: PP Mori;
font-weight: 500;
font-style: Medium;
font-size: 12px;
leading-trim: NONE;
line-height: 130%;
letter-spacing: 0%;
color:#20232799;
margin:0;
`
const PerText2 = styled.h1`
font-family: PP Mori;
font-weight: 600;
font-style: SemiBold;
font-size: 20px;
leading-trim: NONE;
line-height: 110.00000000000001%;
letter-spacing: -1%;
color:#202327;
margin:0;
`
const QItem = styled.div`

height: 132px;
border-radius: 24px;
padding: 24px;
gap: 24px;
background: #FFFFFF;
box-shadow: 0px 0px 24px 0px #2F323705;
flex: 0 0 calc(50% - 8px);
`
const Q1 = styled.div`

height: 84px;
gap:12px;
display:flex;
flex-direction:column;

`

const Q = styled.div`
display:flex;
gap:16px;
align-items:center;
// justify-content:center;
flex-wrap: wrap;
padding-left:20px;
width:60%;
`
const II = styled.div`
display:flex;
flex: 1 1 0;
min-width: 0;
height:349px;
gap:24px;
flex-direction:column;
`
const In61Text1 = styled.p`
font-family: PP Mori;
margin:0;
font-weight: 500;
font-style: Medium;
font-size: 10px;
leading-trim: NONE;
line-height: 130%;
letter-spacing: 0%;
text-align: center;
color:#20232799;
`

const In61Text2 = styled.p`
font-family: PP Mori;
font-weight: 700;
margin:0;
font-style: Bold;
font-size: 14px;
leading-trim: NONE;
line-height: 120%;
letter-spacing: -1%;
text-align: center;
vertical-align: bottom;
color:#000000;
`
const In6 = styled.div`
height:38px;
justify-content:space-between;
display:flex;
align-items:center;
`
const In61 = styled.div`

height: 38px;
gap: 8px;
display:flex;
flex-direction:column;
align-items:center;

box-shadow: 0px 0px 24px 0px #2F323705;

`

const In513Text = styled.p`
font-family: PP Mori;
font-weight: 700;
font-style: Bold;
font-size: 11px;
leading-trim: NONE;
line-height: 120%;
letter-spacing: 0%;
text-align: center;
vertical-align: bottom;
text-transform: uppercase;
color:#000000;

`
const In513 = styled.div`

height: 22px;
padding-right:12px;
padding-left:12px;
border-radius: 24px;
gap: 24px;
display:flex;
align-items:center;
justify-content:center;
background: #FFFFFF;
box-shadow: 0px 0px 24px 0px #2F323705;

`
const In512 = styled.div`
padding-top:12px;
padding-bottom:12px;

`
const In511 = styled.div`
position: absolute;
  bottom: 0;
  left: 0;
border-radius: 24px;
// background: linear-gradient(
//   to bottom,
//   #BDDEFF 0%,
//   #EFFFB9 50%,
//   #DCFFAD 100%
// );



align-items:end;
display:flex;
justify-content:center;
width:100%;


`
const In5 = styled.div`
display:flex;
gap:24;
flex-direction:column;


`
const In51 = styled.div`
gap:10px;
display:flex;


`
const In41 = styled.div`
display:flex;

width:100%;

justify-content:space-between;
align-items:center;
`
const In411 = styled.div`
align-items:center;
display:flex;
gap:6px;

`
const In411Text1 = styled.p`
font-family: PP Mori;
font-weight: 700;
font-style: Bold;
font-size: 12px;
leading-trim: NONE;
line-height: 120%;
letter-spacing: -1%;
text-align: center;
vertical-align: bottom;
text-transform: uppercase;
color:#20232799;
`
const In411Text2 = styled.p`
font-family: PP Mori;
font-weight: 700;
font-style: Bold;
font-size: 12px;
leading-trim: NONE;
line-height: 120%;
letter-spacing: -1%;
text-align: center;
vertical-align: bottom;
text-transform: uppercase;
color:#202327;
`
const In4Text = styled.h1`
font-family: PP Mori;
font-weight: 700;
font-style: Bold;
font-size: 24px;
leading-trim: NONE;
line-height: 120%;
letter-spacing: -1%;
text-align: center;
color:#202327;
`

const In4 = styled.div`
border-radius: 18px;
padding: 30px;
gap: 48px;
flex-direction:column;
display:flex;
background: #F9F9F9;


`
const In = styled.div`
display:flex;
justify-content:space-between;
align-items:center;

`

const BackToTopButton = styled.button`
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #F9F9F9;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  z-index: 1000;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: translateY(0);
  }
`;
const In2 = styled.div`
display:flex;
gap: 8px;


`
const Container = styled.div`
  height: 100vh;
  overflow-y: auto;

  gap: 30px;
  border: 0px 1px 0px 0px;
  opacity: 0px;
  padding: 30px;
  gap: 30px;
  border-right-width: 1px;
`;
const InnerContainer = styled.div`


border-radius: 24px;
padding: 24px;
gap: 24px;
display:flex;
background: #FFFFFF;
box-shadow: 0px 0px 24px 0px #2F323705;
flex-direction:column;


`

const In1 = styled.div`
height: 46px;
display:flex;
gap: 12px;
align-items:center;
`
const In1Text = styled.h1`
font-family: PP Mori;
font-weight: 600;
font-style: SemiBold;
font-size: 42px;
leading-trim: NONE;
line-height: 110.00000000000001%;
letter-spacing: -1%;
color:#202327;
`

const Tag = styled.div`

height: 27px;
border-radius: 4px;
gap: 10px;
// padding-top: 4px;
padding-right: 8px;
// padding-bottom: 4px;
padding-left: 8px;
justify-content:center;
align-items:center;
display:flex;

background: linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%);


`

const In31 = styled.div`
height: 27px;
border-radius: 4px;
padding-right: 8px;
padding-left: 8px;
justify-content:center;
align-items:center;
display:flex;
gap:6px;
background: #2023271A;

`
const TagText = styled.h1`
font-family: PP Mori;
font-weight: 700;
font-style: Bold;
font-size: 14px;
leading-trim: NONE;
line-height: 120%;
letter-spacing: -1%;
text-align: center;

text-transform: uppercase;
color: #202327;

`

const DropdownWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items:center;
  padding-right:12px;
  padding-left:12px;

   white-space: normal;        
  word-break: break-word;    
  overflow-wrap: break-word; 

  
`;

const DropdownInput = styled.div`
  width: 100%;
  padding: 12px;
  font-size: 14px;
  font-weight: 600;
  line-height: 16.8px;
  color: #20232799;
  border: 1px solid #d1d1d1;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  background: #FFFFFF;
  align-items: center;
  padding: 12px;
  

gap: 0px;
border-radius: 12px;
display:flex;


  
border:none;
  outline:none;
  &:hover {
    border-color: #000; /* Optional hover effect */
  }
`;

const OptionsList = styled.ul`
  position: absolute;
  
  top: calc(100% + 4px);
  width: 100%;
  list-style: none;
  margin: 0;
  padding: 0px ;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 10px 24px rgba(24, 25, 26, 0.1);
  z-index: 10000000;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  
`;

const DropdownOption = styled.li`
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  color: #202327;
  cursor: pointer;

  &:hover {
    background: linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%);
    
    
  }
`;

const DiscoveryTagPill = styled.div`
  padding: 5px 8px;
  border-radius: 6px;
  font-family: PP Mori;
  font-weight: 800;
  font-size: 11px;
  // line-height: 120%;
  white-space: nowrap;
  background: ${({ color }) => tagColors[color]?.bg || '#2023271A'};
  color: ${({ color }) => tagColors[color]?.text || '#202327'};
`;
export default Trend;